import React from 'react';
import {
  LayoutDashboard,
  Sigma, 
  ShieldAlert, 
  Activity, 
  FileCheck, 
  Network, 
  Search, 
  LineChart, 
  Newspaper, 
  Lightbulb, 
  Menu, 
  X, 
  Command, 
  Sparkles, 
  Zap, 
  Bell, 
  Trash2, 
  FileText, 
  Shield, 
  Mail, 
  Stamp, 
  Globe, 
  Landmark, 
  Wallet, 
  Target, 
  Code, 
  Cpu, 
  Scale, 
  CheckCircle, 
  Building2, 
  Briefcase, 
  Workflow, 
  Server, 
  Play, 
  Pause, 
  PieChart, 
  Terminal, 
  Filter, 
  List, 
  Eye, 
  EyeOff, 
  TrendingUp, 
  TrendingDown, 
  Layers, 
  Clock, 
  FolderOpen, 
  FileUp, 
  ChevronDown, 
  ChevronRight, 
  Scan, 
  Box, 
  FileCode, 
  GitBranch, 
  Calendar, 
  Lock, 
  Siren, 
  Settings, 
  Users, 
  GitMerge, 
  BarChart3, 
  Presentation, 
  BadgeCheck, 
  Sliders, 
  PenTool, 
  Layout, 
  Gift, 
  Phone, 
  ThumbsUp, 
  MessageSquare, 
  Hash, 
  AtSign, 
  Send,
  ArrowUp,
  RefreshCw,
  ArrowDown,
  Book,
  Table,
  Brain,
  ArrowRight,
  AlertTriangle,
  Plus,
  Save,
  BarChart,
  Info,
  ShieldCheck,
  Printer,
  Quote, 
  Check
} from 'lucide-react';

// --- FRONT OFFICE ---
export const IconDashboard = LayoutDashboard;
export const IconQuant = Sigma;
export const IconStrategy = Lightbulb;
export const IconSearch = Search;
export const IconMarketData = LineChart;
export const IconNews = Newspaper;
export const IconBriefcase = Briefcase;
export const IconTarget = Target;
export const IconCode = Code;
export const IconChartPie = PieChart;
export const IconPie = PieChart;
export const IconChartBar = BarChart3;
export const IconPresentationChart = Presentation;
export const IconPenTool = PenTool;
export const IconGlobeAlt = Globe; // Mapped to Globe
export const IconScan = Scan;

// --- RISK & MIDDLE OFFICE ---
export const IconRisk = ShieldAlert;
export const IconIPV = FileCheck;
export const IconShield = Shield;
export const IconCollateral = Shield; // Fallback
export const IconCompliance = EyeOff; // Fallback
export const IconScale = Scale;
export const IconBalance = Scale; // Mapped to Scale as Balance
export const IconBadgeCheck = BadgeCheck;
export const IconEye = Eye;
export const IconEyeOff = EyeOff;
export const IconLock = Lock;
export const IconSiren = Siren;

// --- BACK OFFICE & OPS ---
export const IconOps = Activity;
export const IconActivity = Activity;
export const IconWorkflow = Workflow; // Renamed flow -> workflow
export const IconFlow = Workflow;
export const IconReconciliation = Scale;
export const IconStamp = Stamp;
export const IconBank = Landmark;
export const IconTreasury = Landmark;
export const IconWallet = Wallet;
export const IconRegulatory = Stamp;
export const IconServer = Server;
export const IconDatabase = Server;
export const IconLayers = Layers;
export const IconClock = Clock;
export const IconCalendar = Calendar;

// --- SYSTEM & UI ---
export const IconMenu = Menu;
export const IconClose = X;
export const IconCommand = Command;
export const IconBell = Bell;
export const IconSettings = Settings;
export const IconArchitecture = Network;
export const IconHierarchy = GitMerge;
export const IconTerminal = Terminal;
export const IconCpu = Cpu;
export const IconZap = Zap;
export const IconLightning = Zap;
export const IconSparkles = Sparkles;
export const IconTrash = Trash2;
export const IconFileText = FileText;
export const IconReport = FileText;
export const IconMail = Mail;
export const IconBuilding = Building2;
export const IconFilter = Filter;
export const IconList = List;
export const IconFolderOpen = FolderOpen;
export const IconFileUp = FileUp;
export const IconChevronDown = ChevronDown;
export const IconChevronRight = ChevronRight;
export const IconCube = Box;
export const IconPython = FileCode; // Mapped to FileCode
export const IconGit = GitBranch;
export const IconLayout = Layout;
export const IconGift = Gift;
export const IconUserGroup = Users;
export const IconUsers = Users;
export const IconPhone = Phone;
export const IconThumbUp = ThumbsUp;
export const IconChat = MessageSquare;
export const IconHash = Hash;
export const IconAtSign = AtSign;
export const IconPaperAirplane = Send;
export const IconCheckCircle = CheckCircle;
export const IconPlay = Play;
export const IconPause = Pause;
export const IconTrendingUp = TrendingUp;
export const IconTrendingDown = TrendingDown;
export const IconSliders = Sliders;
export const IconGlobe = Globe;
export const IconArrowUp = ArrowUp;
export const IconRefresh = RefreshCw; // Mapped to ArrowUp as Refresh
export const IconArrowDown = ArrowDown; // Mapped to ArrowUp as ArrowDown (No specific icon)
export const IconBook = Book;
export const IconTable = Table;
export const IconBrain = Brain;
export const IconArrowRight = ArrowRight
export const IconAlertTriangle = AlertTriangle
export const IconPlus = Plus
export const IconX = X;
export const IconSave = Save;
export const IconBarChart = BarChart;
export const IconInfo = Info;
export const IconShieldCheck = ShieldCheck
export const IconPrinter = Printer
export const IconQuote = Quote
export const IconCheck = Check

// WhatsApp brand icon (not in lucide-react)
export const IconWhatsApp: React.FC<{ size?: number; className?: string }> = ({ size = 16, className = '' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
);
